MemberBoardsListAdView = require 'views/ads/member-boards-list-ad-view'
Util = require 'lib/util'
templates = require 'views/internal/templates'

module.exports = class BusinessClassAdView extends MemberBoardsListAdView
  @adId: 'BoardsListBC'
  @isEligible: (member) ->
    olderThan = (model, timeSpec) ->
      Util.idToDate(model.id) < Util.dateBefore(timeSpec)

    if !olderThan(member, { months: 1 })
      # Don't bother new members with ads ... yet
      return

    # We show the business class ad if ...
    # - They aren't already in a business class org
    # - They're in an organization that's more than a week old
    memberOrgs = member.organizationList
    isInBCOrg = memberOrgs.any (org) -> org.isPremium()
    isInOlderOrg = memberOrgs.any (org) -> olderThan(org, { weeks: 1 })

    !isInBCOrg && isInOlderOrg

  className: 'member-boards-list-ad business-class-ad
              window-title-extra--bc-pitch'

  copyHtml: ->
    templates.fill('ad_business_class')

  click: ->
    super
    window.open('/business-class', '_blank')



// WEBPACK FOOTER //
// ./app/scripts/views/ads/business-class-ad-view.coffee